import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AuthShell } from '../../../../components/AuthShell';
import { redirectIfSignedIn } from '../../../../lib/guards';

// Signed-out pages (welcome, onboarding, sign-in, ...) share the two-column auth shell.
export const Route = createFileRoute('/subdomain/app/_auth')({
  beforeLoad: ({ context, location }) => redirectIfSignedIn(context.queryClient, location.pathname),
  component: () => (
    <AuthShell>
      <Outlet />
    </AuthShell>
  ),
});
